import { SvgIcon } from '../../../mui/SvgIcon';
import { UxSvgIconProps } from '../ux/types';

export function BpTickCircle(props: UxSvgIconProps) {
  return (
    <SvgIcon {...props} preserveAspectRatio='xMidYMid meet' viewBox='0 0 16 16'>
      <path
        d='M8,16c-4.42,0-8-3.58-8-8s3.58-8,8-8s8,3.58,8,8S12.42,16,8,16z M12,5c-0.28,0-0.53,0.11-0.71,0.29
		L7,9.59l-2.29-2.3C4.53,7.11,4.28,7,4,7C3.45,7,3,7.45,3,8c0,0.28,0.11,0.53,0.29,0.71l3,3C6.47,11.89,6.72,12,7,12
		s0.53-0.11,0.71-0.29l5-5C12.89,6.53,13,6.28,13,6C13,5.45,12.55,5,12,5z'
      />
    </SvgIcon>
  );
}
